import { motion, AnimatePresence } from 'framer-motion';
import ReactDOM from 'react-dom';

//ASSETS
import { faArrowDownLong, faArrowRightLong, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//STYLES
import { ContainerModalPO as StyledContainerModalPO } from './style';
import { Popconfirm } from 'antd';
import { Inline } from '../inline';
import ButtonCustom from '../../ButtonCustom';
import { useState } from 'react';

//CONST
const ContainerModalPO = motion(StyledContainerModalPO);

//PROPS
interface Props {
    open: boolean;
    onClose: Function;
    title: string;
    children?: React.ReactNode;
    width?: number;
    height?: number | string;
    top: number;
    right: number;
    confirm_onClose?: boolean;
}

export const ModalPopOver: React.FC<Props> = ({ open, onClose, title, children, width, top, right, height, confirm_onClose }) => {

    //STATES
    const [open_confirm, setOpen_confirm] = useState<boolean>(false);

    return ReactDOM.createPortal(
        <AnimatePresence>

            {open &&(
                <ContainerModalPO 
                    style={{width: width, height: height, top: top, right: right}}
                    initial={{ opacity: 0.5, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 80 }}
                    transition={{ duration: 0.8, ease: [0, 0.71, 0.2, 1.01], exit: { duration: 0.1, ease: [0, 1.21, 0.77, 0.91] } }}
                >
                    <div className='ContainerModalPO__header'>
                        {title}

                        <Popconfirm
                            destroyTooltipOnHide
                            placement={"left"}
                            title={'Você não salvou o cadastro?'}
                            open={open_confirm}
                            description={
                            <div style={{display:'flex',flexDirection:'column',gap:15}}>
                                <span>Deseja fechar sem salvar? Todas as informações inseridas serão perdidas.</span>
                                <Inline justifyContent="flex-end">

                                    <ButtonCustom
                                        onClick={()=>{setOpen_confirm(false);onClose()}}
                                        type={"tertiary"}
                                        icon={<FontAwesomeIcon icon={faXmark} />}
                                        danger
                                    >
                                        Fechar
                                    </ButtonCustom>

                                    <ButtonCustom 
                                        onClick={()=>{setOpen_confirm(false)}}
                                        icon={<FontAwesomeIcon icon={faArrowDownLong} />}
                                    >
                                        Voltar para o cadastro
                                    </ButtonCustom>

                                </Inline>
                            </div>}
                            okButtonProps={{style: {display:'none'}}}
                            cancelButtonProps={{style: {display:'none'}}}
                            style={{zIndex: '9999999999 !important'}}
                        >
                            <button className='ContainerModalPO__header__close' onClick={confirm_onClose ? ()=>setOpen_confirm(true) : ()=>{onClose()}}>
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                        </Popconfirm>
                    </div>

                    <div className='ContainerModalPO__body'>
                        {children}
                    </div>
                    
                    
                </ContainerModalPO>
            )}
            
        </AnimatePresence>,

        document.getElementById('portal')
    );
}